import { InjectionToken } from '@angular/core';

export const GLOBALS = new InjectionToken<any>('Global config for sortablejs');
